import React from 'react';
import cx from 'classnames';
import MobileDetect from 'mobile-detect';
import Loader from '../Loader';
import { Animate } from 'react-move';
import { easeCubic } from 'd3-ease';
import * as d3 from 'd3';

const commas = d3.format(',');

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

let updateT = 0.95;
export default class Steps extends React.Component {
  state = {
    saving: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.parameters.savePdf && !this.props.parameters.savePdf) {
      this.setState({ saving: false });
    }
  }
  ftIn = inches => {
    return Math.floor(inches / 12) + "'-" + Math.ceil(inches % 12) + '"';
  };
  steps = [
    { title: 'Dimensions', step: '01' },
    { title: 'Layout Options', step: '02' },
    { title: 'Rack Options', step: '02b' },
    { title: 'Architectural Layout', step: '03' },
    { title: '3D Scene', step: '04' }
  ];
  pdfEnabled = false;
  render() {
    const { steps } = this;
    if (!this.props.configuration.dim) {
      return null;
    }
    const {
      configuration: {
        dim: { length, width, walkway },
        types: { top, bottom, fields }
      },
      handleNext,
      handlePrev,
      handleStepSet,
      step,
      isRiderFriendly
    } = this.props;
    if (step >= 3) {
      this.pdfEnabled = true;
    }

    this.bottomCount = fields
      ? Math.max(fields.fields * fields.count, bottom.count)
      : bottom.count;

    return (
      <div className='step-control-container'>
        {
          <Animate
            start={() => ({ width: 0, length: 0, bikes: 0 })}
            enter={() => ({
              width: [width],
              length: [length],
              bikes: [top.count * 2 + this.bottomCount * 2],
              timing: { duration: 600 }
            })}
            update={() => ({
              width: [width],
              length: [length],
              bikes: [top.count * 2 + this.bottomCount * 2],
              timing: { duration: 600 },
              events: {
                start: () => {
                  updateT = 1.2;
                },
                end: () => {
                  updateT = 0.95;
                }
              }
            })}
          >
            {({ width, length, bikes }) => {
              return (
                <div className='ticker-dash-container'>
                  <div className='bike-count'>
                    {commas(Math.round(bikes))} bikes
                  </div>
                  {!isMobile && (
                    <div className='ticker-dash'>
                      <div className='metadata-configuration-ticker'>
                        <div>
                          Room size: {this.ftIn(Math.round(width))} x{' '}
                          {this.ftIn(Math.round(length))}"
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            }}
          </Animate>
        }
        <div className='step-control-container-inner'>
          <div className='step-inner-steps'>
            {!isMobile ? (
              steps
                .map((s, i) => {
                  return (
                    <div
                      key={i}
                      className={cx({ 'step-text': true, active: step === i })}
                      onClick={() => {
                        handleStepSet(i, false, true);
                      }}
                    >
                      <div className='step-number'>{s.step}</div>
                      <div className='step-name'>{s.title}</div>
                    </div>
                  );
                })
                .filter((el, i) => i !== 2 || !isRiderFriendly)
            ) : (
              <div
                className={cx({ 'step-text': true, active: true })}
                onClick={() => {
                  // handleStepSet(i);
                }}
              >
                <div className='step-number'>{steps[step].step}</div>
                <div className='step-name'>{steps[step].title}</div>
              </div>
            )}
          </div>
          <div className='step-control-button-container'>
            <div className='step-control-button-left'>
              {/* <button onClick={handlePrev}>Prev</button> */}
              <button onClick={handlePrev} disabled={step === 0}>
                Prev
              </button>
              <button onClick={handleNext} disabled={step === 4}>
                Next
              </button>
            </div>
            <div className='step-control-button-right'>
              {/* <button onClick={handlePrev}>Prev</button> */}

              {!isMobile && this.pdfEnabled && (
                <button
                  onClick={() => {
                    this.setState({ saving: true }, () => {
                      setTimeout(() => {
                        this.props.actions.savePdfOn();
                      }, 0);
                    });
                  }}
                >
                  {this.state.saving ? 'Building' : 'Save'} PDF
                  {this.state.saving && <Loader />}
                </button>
              )}
              {!isMobile && (
                <a href='https://www.groundcontrolsystems.com/contact-us/'>
                  <button>Get Quote</button>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/index.js